var map = {
	"./apache.svg": "b77f",
	"./casScreen.png": "a06b",
	"./comingSoon.jpg": "aeb1",
	"./css3.svg": "fa59",
	"./flask.png": "218d",
	"./heroimage.jpg": "382a",
	"./html5.svg": "10a4",
	"./java.svg": "b219",
	"./javascript.svg": "3c64",
	"./jobjugScreen.png": "f6ec",
	"./kneadpizzaScreen.png": "792b",
	"./mariadb.svg": "613e",
	"./node-js.svg": "dec2",
	"./nov21Mg.png": "1d5b",
	"./placeholder.png": "5b4d",
	"./portfolioScreen.png": "40a6",
	"./python.svg": "055b",
	"./react.svg": "b2e9",
	"./tweeterScreen.png": "78ad",
	"./vue.svg": "038d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";